const GlideOptions = {
	type: 'carousel',
	startAt: 0,
	perView: 1,
	gap: 20,
	animationDuration: 600
}

document.querySelectorAll('.js-slider').forEach(function (sliderElement) {
	let glide = new Glide(sliderElement, GlideOptions);

	let progressBarLineElement = sliderElement.querySelector('.js-progressbar-line');
	let numberOfSteps = progressBarLineElement.getAttribute('data-number-of-steps');

	glide.on('mount.after', function () {
		progressBarLineElement.style.width = ((100 / numberOfSteps) * (glide.index + 1)) + '%';
	})

	glide.on('run', function () {
		progressBarLineElement.style.width = ((100 / numberOfSteps) * (glide.index + 1)) + '%';
	})

	glide.mount();
});
